import _ from 'lodash';
import template from './ptzGrid.html';

/* @ngInject */
function PTZGridController($scope, $element) {
  const vm = this;

  let svg;
  let pt;

  let rect;

  let mousedown = false;
  let rectDrawn = false;
  const minBoxWidth = 1;

  let tempX;
  let tempY;

  const coords = {
    upperLeftX: 0,
    upperLeftY: 0,
    boxWidth: 0,
    boxHeight: 0
  };

  vm.stopPtzLoader = false;

  vm.$postLink = postLink;
  vm.$onDestroy = destroy;
  vm.initializeMousedown = initializeMousedown;

  function postLink() {
    const svgWatcher = $scope.$watch(() => $(`#ptz-grid-${vm.camId}`, $element).length, (newV) => {
      if (newV) {
        svgWatcher();
        svg = $(`#ptz-grid-${vm.camId}`, $element)[0];
        pt = svg.createSVGPoint();

        drawRect();
        attachEventListeners();

        vm.stopPtzLoader = true;
      }
    });
  }

  function destroy() {
    document.querySelector('body').removeEventListener('mousemove', resizeAreaRect);
  }

  function attachEventListeners() {
    svg.addEventListener('mousedown', initializeMousedown);
    document.querySelector('body').addEventListener('mousemove', resizeAreaRect);
    svg.addEventListener('mouseup', moveToCenterOrArea);
    svg.addEventListener('mouseleave', cancelPtzMovement);
  }

  /**
   * Creates a rectangle element and appends it to the svg element.
   *
   * @returns {undefined}
   */
  function drawRect() {
    if (!rect) {
      rect = new Rect();
      document.getElementById(`ptz-grid-${vm.camId}`).appendChild(rect);
    }
  }

  /**
   * Creates and Initializes the rect.
   *
   * @returns {Element} - an svg rect
   */
  function Rect() {
    const svgRect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');

    svgRect.setAttribute('stroke', 'yellow');
    svgRect.setAttribute('stroke-width', '1');
    svgRect.style.display = 'none';

    return svgRect;
  }

  /**
   * Upon mousedown/touch, turns mousedown boolean to true and assigns current mouse coordinates for later use.
   *
   * @param {Event} evt - Event
   *
   * @returns {undefined}
   */
  function initializeMousedown(evt) {
    mousedown = true;
    const { x, y } = cursorPoint(evt);

    tempX = x;
    tempY = y;
  }

  /**
   * Upon mouseup/touchend, cancels mousemove and hides rectangle.
   *
   * @returns {undefined}
   */
  function cancelPtzMovement() {
    mousedown = false;
    rectDrawn = false;
    rect.style.display = 'none';
  }

  /**
   * Upon mousemove/touchmove, if mousedown has been initialized, turns rectDrawn boolean true (thus, triggering
   * a movement by area), recalculates the rectangle's dimensions, then assigns those new values to the rect element.
   *
   * @param {Event} evt - browser event
   *
   * @returns {undefined}
   */
  function resizeAreaRect(evt) {
    if (mousedown) {
      const { x, y } = cursorPoint(evt);
      rectDrawn = true;

      adjustDimensions(x, y, tempX, tempY, coords);
      resizeRect(rect, coords);
    }
  }

  /**
   * Accepts a dimensions object and alters its values in relation to the current x and y and the initial oldX and oldY.
   *
   * @param {number} x - the current x
   * @param {number} y - the current y
   * @param {number} oldX - the initial x
   * @param {number} oldY - the initial y
   * @param {object} dimensions - coordinates
   * @param {number} dimensions.upperLeftX - x coordinate of rect's upper left corner
   * @param {number} dimensions.upperLeftY - y coordinate of rect's upper left corner
   * @param {number} dimensions.boxHeight - rect's height
   * @param {number} dimensions.boxWidth - rect's width
   *
   * @returns {undefined}
   */
  function adjustDimensions(x, y, oldX, oldY, dimensions) {
    const parentSize = getSvgSize(svg);
    let widthPercent;
    if (x > oldX && y > oldY) {
      widthPercent = convertToPercent(x - oldX, parentSize.width);
      dimensions.upperLeftX = oldX;
      dimensions.upperLeftY = oldY;
    } else if (x < oldX && y > oldY) {
      widthPercent = convertToPercent(oldX - x, parentSize.width);
      dimensions.upperLeftX = x;
      dimensions.upperLeftY = oldY;
    } else if (x < oldX && y < oldY) {
      widthPercent = convertToPercent(oldX - x, parentSize.width);
      dimensions.upperLeftX = x;
      dimensions.upperLeftY = oldY - convertFromPercent(widthPercent, parentSize.height);
    } else if (x > oldX && y < oldY) {
      widthPercent = convertToPercent(x - oldX, parentSize.width);
      dimensions.upperLeftX = oldX;
      dimensions.upperLeftY = oldY - convertFromPercent(widthPercent, parentSize.height);
    }

    dimensions.boxWidth = widthPercent;
    dimensions.boxHeight = widthPercent;
  }

  /**
   * Assigns the new dimensions to the rect element if a width and height exist to resize while being dragged.
   *
   * @param {Element} rectEl the rect element
   * @param {object} dimension
   * @param {number} dimension.upperLeftX
   * @param {number} dimension.upperLeftY
   * @param {number} dimension.boxWidth
   * @param {number} dimension.boxHeight
   *
   * @returns {Element} - the rect with new attributes and a display of 'block'
   */
  function resizeRect(rectEl, { upperLeftX, upperLeftY, boxWidth, boxHeight }) {
    if (boxWidth && boxHeight) {
      rectEl.setAttribute('x', upperLeftX);
      rectEl.setAttribute('y', upperLeftY);
      rectEl.setAttribute('width', `${boxWidth}%`);
      rectEl.setAttribute('height', `${boxHeight}%`);
      rectEl.style.display = 'block';
    }
    return rectEl;
  }

  /**
   * If the rect element has been drawn, move the camera to pan/tilt and zoom of the rectangle's area, otherwise,
   * move the pan/tilt to the center of the event.
   *
   * @param {Event} evt - browser event
   *
   * @returns {undefined}
   */
  function moveToCenterOrArea(evt) {
    if (rectDrawn && coords.boxWidth > minBoxWidth) {
      moveToArea();
    } else if (mousedown) {
      moveToCenter(evt);
    }

    cancelPtzMovement();
  }

  /**
   * Uses the svg and rectangle's size to calculate the area and center of the rect, then places those in a string on
   * an areazoom property to send to sendPtzMovementRequest.
   *
   * @returns {undefined}
   */
  function moveToArea() {
    const svgSize = getSvgSize(svg);
    const rectSize = getSvgSize(rect);

    const center = calculateRectCenter(coords, svgSize);
    const area = calculateRectArea(rectSize, svgSize);

    // Cameras use the 'center' and 'area' values in this format to move and zoom upon a fixed area, drawn in this
    // component with a rectangle
    sendPtzMovementRequest({ areazoom: `${center},${Math.round(area)}` });
  }

  /**
   * Wraps x, y coordinates into string on center property, then calls sendPtzMovementRequest.
   *
   * @param {Event} evt - browser event
   *
   * @returns {undefined}
   */
  function moveToCenter(evt) {
    const { x, y } = cursorPoint(evt);

    // With single click, camera can move to the new 'center' just by using the x,y values.
    sendPtzMovementRequest({ center: `${Math.round(x)},${Math.round(y)}` });
  }

  /**
   * @typedef {object} Size
   * @property {number} width
   * @property {number} height
   */

  /**
   * Calculates and returns the x and y coordinates of the center of the rect element.
   *
   * @param {object} dimensions - container of coordinates
   * @param {number} dimensions.upperLeftX - x coordinate of rect's upper left corner
   * @param {number} dimensions.upperLeftY - y coordinate of rect's upper left corner
   * @param {number} dimensions.boxHeight - rect's height
   * @param {number} dimensions.boxWidth - rect's width
   * @param {Size} parentSize - size of parent container
   *
   * @returns {string} - the x,y of the rect's center
   */
  function calculateRectCenter(dimensions, parentSize) {
    const xCenter =
      Math.round(dimensions.upperLeftX + (convertFromPercent(dimensions.boxWidth, parentSize.width) / 2));
    const yCenter =
      Math.round(dimensions.upperLeftY + (convertFromPercent(dimensions.boxHeight, parentSize.height) / 2));

    return `${xCenter},${yCenter}`;
  }

  /**
   *
   * @param {Size} childBox - Child sizes.
   * @param {Size} parentBox - Parent sizes
   *
   * @returns {number} - the calculated area of the child element within the parent
   */
  function calculateRectArea(childBox, parentBox) {
    return 100 / ((childBox.width - childBox.height) / (parentBox.width - parentBox.height));
  }

  /**
   * Merges the paramsToMerge object into an object of key/value pairs the camera require to ptz, then passes that
   * object to the alterPtz binding function on a params property.
   *
   * @param {object} paramsToMerge - contains a property of either center or areazoom
   *
   * @returns {undefined}
   */
  function sendPtzMovementRequest(paramsToMerge) {
    const size = getSvgSize(svg);
    let timestamp = new Date();
    timestamp = timestamp.getTime();

    const params = _.assign({
      camera: 1,
      speed: 100,
      imagewidth: Math.round(size.width),
      imageheight: Math.round(size.height),
      imagerotation: vm.rotation,
      timestamp
    }, paramsToMerge);
    vm.alterPtz({ params });
  }

  // TODO: extract the next two methods into the appropriate helper
  /**
   * Calculates the percentage of the partialSize to the fullSize.
   *
   * @param {number} partialSize - the integer <= fullSize
   * @param {number} fullSize - the integer >= partialSize
   *
   * @returns {number} percentage from 0 to 100
   */
  function convertToPercent(partialSize, fullSize) {
    return (partialSize / fullSize) * 100;
  }

  /**
   * Calculates the integer amount from the percentage of the fullSize.
   *
   * @param {number} percent - 0 to 100
   * @param {number} fullSize - the actual size integer
   *
   * @returns {undefined}
   */
  function convertFromPercent(percent, fullSize) {
    return (percent * fullSize) / 100;
  }

  function cursorPoint(evt) {
    if (evt.clientX) {
      pt.x = evt.clientX;
      pt.y = evt.clientY;
    } else {
      pt.x = evt.changedTouches[0].clientX;
      pt.y = evt.changedTouches[0].clientY;
    }

    return pt.matrixTransform(svg.getScreenCTM().inverse());
  }

  /**
   *
   * @param {Element} svgEl - The svg.
   *
   * @returns {Size} - the raw height and width values of the svg
   */
  function getSvgSize(svgEl) {
    const { width, height } = svgEl.getBoundingClientRect();
    return {
      width,
      height
    };
  }
}

export default {
  name: 'ptzGrid',
  template,
  controller: PTZGridController,
  bindings: {
    camId: '<',
    rotation: '<',
    alterPtz: '&'
  }
};
